import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";

import { EditorialCard } from "@/types";

const EditorialInventoryCard: FC<{ item: EditorialCard }> = ({ item }) => {
  const t = useTranslations();
  return (
    <>
      <Link href={item.url} target="_blank">
        <div className="w-full md:w-fit relative ">
          <div className="relative">
            <Image
              src={item.images?.[0].url}
              width={255}
              height={453}
              className="aspect-1-1 w-full md:w-[255px] md:h-[453px] rounded-lg shadow-elevation object-cover"
              alt={item.images?.[0].title}
            />
            <div className="absolute w-full h-full top-0 left-0 inset-0 img-overlay-3"></div>
          </div>
          {item.logo && (
            <div className="w-1/2 absolute bottom-0 right-0 md:right-none md:top-0 md:w-full text-white py-xs flex justify-center">
              <Image
                src={"images/logo_inventory.png"}
                width={120}
                height={68}
                className="w-[107px] h-[60px] md:w-[120px] md:h-[68px]"
                alt={t("alt.inventory.logo")}
              />
            </div>
          )}
          <div className="absolute bottom-0 z-10 text-white px-s py-m ">
            <div className="font-secondary text-m leading-5 pb-xxs">{item.title}</div>
            <div className="font-secondary text-s leading-4">{item.subTitle}</div>
          </div>
        </div>
      </Link>
    </>
  );
};
export default EditorialInventoryCard;
